import * as yup from "yup";

const createUserSchema = yup.object().shape({
  name: yup.string().required(),
  email: yup
    .string()
    .email()
    .required("E-mail is a required field")
    .transform((value, originalValue) => originalValue.toLowerCase()),
  password: yup
    .string()
    .required("Password is a required field")
    .min(8, "Password must be at least 8 characters"),
  confirmPassword: yup
    .string()
    .oneOf([yup.ref("password"), null], "Passwords must match"),
});

export default createUserSchema;
